import React, { useState } from 'react';
import usePostUpdateChemicalRob from '../../../api/usePostUpdateChemicalRob';
import { useAuthStore } from '../../../context/AuthContext';
import { useTankCleaningStore } from '../../../context/TankCleaningContext';
import { ButtonWrapper, TabLineButton } from '../../../styles/button.style';
import { OrderInfoWrapper } from '../../../styles/panel.style';
import mapTankCleaningUtils from '../../../utils/mapTankCleaningUtils';
import PrintRobUpdateInfo from './PrintRobUpdateInfo';
import { HeaderWrapper, LeftContentWrapper, PrintInfo, RightContentWrapper } from './ReportRob.styles';
import { useToast } from '../../../app/useToast';
import { useVesselStore } from '../../../context/VesselContext';
import { ConfirmDeleteAol } from '../../aol/aol-main/AolMain.style';
import { RoleTypeEnum } from '../../../enums/roleTypeEnum';
import UpdateInfo from '../../common/UpdateInfo';

const ChemicalRobHeader: React.FC = () => {
    const { selectedTankCleaningPortCall, selectedChemicalRobForPortCall, chemicalRobUpdateReportData, setShouldCopyLastRob } =
        useTankCleaningStore();
    const { getChemicalRobForPortCallBM } = mapTankCleaningUtils();
    const { upsertChemicalRob } = usePostUpdateChemicalRob();
    const { role } = useAuthStore();
    const { toastError } = useToast();
    const { selectedVessel } = useVesselStore();
    const [showConfirmCopy, setShowConfirmCopy] = useState(false);

    const onCopyPreviousRob = () => {
        if (role && selectedTankCleaningPortCall && selectedTankCleaningPortCall.portCallId && selectedVessel) {
            setShowConfirmCopy(true);
        }
    };

    const copyPreviousRob = () => {
        if (role && selectedTankCleaningPortCall && selectedTankCleaningPortCall.portCallId && selectedVessel) {
            setShouldCopyLastRob(true);
            setShowConfirmCopy(false);
        }
    };

    const onSaveRob = () => {
        if (role && chemicalRobUpdateReportData && selectedTankCleaningPortCall && selectedTankCleaningPortCall.portCallId && selectedVessel) {
            const chemicalRobForPortCallBM = getChemicalRobForPortCallBM(chemicalRobUpdateReportData);
            if (chemicalRobForPortCallBM.chemicalRobItemList.length > 0) {
                upsertChemicalRob(chemicalRobForPortCallBM, selectedVessel?.imoNumber);
            } else {
                toastError('No items to save');
            }
        }
    };

    const cancelCopy = () => {
        setShowConfirmCopy(false);
    };

    return (
        <HeaderWrapper>
            <LeftContentWrapper>
                <PrintInfo>
                    <span>{selectedTankCleaningPortCall?.portCall.voyageNumberPresentationString}</span>
                    <span className="sep"> - </span>
                    {selectedTankCleaningPortCall?.portCall.name}
                </PrintInfo>
            </LeftContentWrapper>

            <RightContentWrapper>
                <OrderInfoWrapper>
                    <UpdateInfo
                        createdUtc={selectedChemicalRobForPortCall?.createdUtc}
                        createdBy={selectedChemicalRobForPortCall?.createdBy}
                        lastUpdatedUtc={selectedChemicalRobForPortCall?.lastUpdatedUtc}
                        lastUpdatedBy={selectedChemicalRobForPortCall?.lastUpdatedBy}
                    ></UpdateInfo>
                    <PrintRobUpdateInfo chemicalRobForPortCall={selectedChemicalRobForPortCall}></PrintRobUpdateInfo>
                </OrderInfoWrapper>
                <ButtonWrapper>
                    {role &&
                        (role.roleType === RoleTypeEnum.Admin ||
                            role.roleType === RoleTypeEnum.ShipUser ||
                            role.roleType === RoleTypeEnum.ShipOperator) && (
                            <TabLineButton type="button" className="primary-btn" disabled={false} onClick={() => onCopyPreviousRob()}>
                                Copy last ROB
                            </TabLineButton>
                        )}

                    {showConfirmCopy && (
                        <ConfirmDeleteAol>
                            <h5>Copy last reported ROB?</h5>
                            <p>This will overwrite form data</p>
                            <div>
                                <button onClick={cancelCopy}>Cancel</button>
                                <button onClick={copyPreviousRob}>Copy</button>
                            </div>
                        </ConfirmDeleteAol>
                    )}

                    {(role.roleType === RoleTypeEnum.Admin ||
                        role.roleType === RoleTypeEnum.ShipUser ||
                        role.roleType === RoleTypeEnum.ShipOperator) && (
                        <TabLineButton type="button" className="primary-btn" disabled={false} onClick={() => onSaveRob()}>
                            Save
                        </TabLineButton>
                    )}
                </ButtonWrapper>
            </RightContentWrapper>
        </HeaderWrapper>
    );
};
export default ChemicalRobHeader;
